import { useContext } from 'react';

import { VendorLeadStepCondition } from 'src/components/vendors/steps/Condition/VendorLeadStepCondition';
import { VendorLeadStepContact } from 'src/components/vendors/steps/Contact/VendorLeadStepContact';
import { VendorLeadStepDescription } from 'src/components/vendors/steps/Description/VendorLeadStepDescription';
import { VendorLeadStepDone } from 'src/components/vendors/steps/Done/VendorLeadStepDone';
import { VendorLeadStepPictures } from 'src/components/vendors/steps/Pictures/VendorLeadStepPictures';
import { VendorLeadStepStart } from 'src/components/vendors/steps/Start/VendorLeadStepStart';
import { VendorsContext } from 'src/pages/VendorsPage/VendorsPage.context';
import { VendorPageStep } from 'src/pages/VendorsPage/VendorsPage.context.types';

type VendorLeadStepsProps = {
  vendorProductLeadId: string;
};

export function VendorLeadSteps({ vendorProductLeadId }: Readonly<VendorLeadStepsProps>) {
  const { vendorStep } = useContext(VendorsContext);

  return vendorStep === VendorPageStep.Start ? (
    <VendorLeadStepStart />
  ) : vendorStep === VendorPageStep.Pictures ? (
    <VendorLeadStepPictures vendorProductLeadId={vendorProductLeadId} />
  ) : vendorStep === VendorPageStep.Description ? (
    <VendorLeadStepDescription vendorProductLeadId={vendorProductLeadId} />
  ) : vendorStep === VendorPageStep.Condition ? (
    <VendorLeadStepCondition vendorProductLeadId={vendorProductLeadId} />
  ) : vendorStep === VendorPageStep.Contact ? (
    <VendorLeadStepContact vendorProductLeadId={vendorProductLeadId} />
  ) : vendorStep === VendorPageStep.Done ? (
    <VendorLeadStepDone />
  ) : null;
}
